import { render, staticRenderFns } from "./CartDelivery.vue?vue&type=template&id=86cdab9c&scoped=true&"
import script from "./CartDelivery.vue?vue&type=script&lang=js&"
export * from "./CartDelivery.vue?vue&type=script&lang=js&"
import style0 from "./CartDelivery.vue?vue&type=style&index=0&id=86cdab9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cdab9c",
  null
  
)

export default component.exports